import React from 'react';
import {
  IMarketplaceTilesAvailabilityCounter,
} from 'src/typings/marketplace';
import { translations } from 'src/constants/translations';
import { updateTranslatedField } from 'src/components/profileComponents/Marketplace/components/Filters/helpers';
import { BoxFormTextField } from 'src/components/profileComponents/FormTextField';
import { BoxFormAutocomplete } from 'src/components/profileComponents/FormAutocomplete';
import {
  GroupWrapperFiltersAction,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction';
import { useStyles as mainUseStyles } from 'src/components/profileComponents/Marketplace/components/Common/styles';
import { GroupWrapper } from 'src/components/profileComponents/Marketplace/components/GroupWrapper';
import {
  GroupWrapperCollapseState,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction/types';
import Box from '@mui/material/Box';
import {
  ThousandsSeparator,
  thousandsSeparatorOptions,
  thousandsSeparatorOptionsMap,
} from 'src/components/profileComponents/Marketplace/types';
import {
  IDevelopmentSpecificationPropChange,
} from 'src/components/profileComponents/Complexes/components/ProjectSpecification/types';
import {
  useStyles,
} from './styles';

interface Props {
  item: IMarketplaceTilesAvailabilityCounter;
  lang: string;
  onChange: (item: IMarketplaceTilesAvailabilityCounter) => void,
}
export const TileAvailabilityCounter: React.FC<Props> = ({ item, lang, onChange }) => {
  const styles = useStyles();
  const mainStyles = mainUseStyles();
  const [collapseState, setCollapseState] = React.useState<GroupWrapperCollapseState>(GroupWrapperCollapseState.OPEN);
  const [rocketState, setRocketState] = React.useState<boolean>(item.isActive);

  const rocketChange = (state: boolean) => {
    onChange({ ...item, isActive: state });
    setRocketState(state);
  };

  return (
    <Box style={{ backgroundColor: 'white' }}>
      <GroupWrapper
        name="Availability counter"
        customStyles={!rocketState ? mainStyles.customGroupWrapperStyles : undefined}
        actions={(
          <GroupWrapperFiltersAction
            collapseState={collapseState}
            rocketState={rocketState}
            onRocket={rocketChange}
            onCollapse={(state) => setCollapseState(state)}
          />
        )}
      >
        { collapseState === GroupWrapperCollapseState.OPEN && (
          <>
            <p>
              This section shows the total number of available units in the project.
            </p>
            <div className={styles.tileWrapper}>
              <BoxFormTextField
                label={translations.availabilityCounterPrefix}
                name="prefix"
                defaultValue={item.prefix?.[lang]}
                onChange={(event) => {
                  onChange(updateTranslatedField(item, 'prefix', lang, event.target.value));
                }}
              />
              <BoxFormTextField
                label={translations.availabilityCounterSuffix}
                name="suffix"
                defaultValue={item.suffix?.[lang]}
                onChange={(event) => {
                  onChange(updateTranslatedField(item, 'suffix', lang, event.target.value));
                }}
              />
              <BoxFormAutocomplete
                label={translations.thousandsSeparator}
                name="thousandsSeparator"
                defaultValue={{
                  label: thousandsSeparatorOptionsMap[item.numberTransformationConfig.thousandsSeparator],
                  value: item.numberTransformationConfig.thousandsSeparator,
                }}
                onChange={(event: IDevelopmentSpecificationPropChange<ThousandsSeparator>) => {
                  onChange({
                    ...item,
                    numberTransformationConfig: {
                      ...item.numberTransformationConfig,
                      thousandsSeparator: event.value,
                    },
                  });
                }}
                options={thousandsSeparatorOptions}
              />
            </div>
          </>
        )}
      </GroupWrapper>
    </Box>
  );
};
